import { render, staticRenderFns } from "./c-actual-tab@.vue?vue&type=template&id=024d5a4c&scoped=true&"
import script from "./c-actual-tab@.vue?vue&type=script&lang=ts&"
export * from "./c-actual-tab@.vue?vue&type=script&lang=ts&"
import style0 from "./c-actual-tab@.vue?vue&type=style&index=0&id=024d5a4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024d5a4c",
  null
  
)

export default component.exports